import { gsap } from "gsap";
import $ from 'jquery';
import { ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

import { pauseAutoPlay, scrollTl, scrollToPosition } from "./_autoPlay";

const isDesktop = $("body").hasClass('desktop')

if($("body").hasClass('page-template-page-sp')) {
    let ease = "power1.inOut"

    $('#join-us-form form input.email').on('blur', function(e){
        $("#join-us-form .mc-field-group div.mce_inline_error").remove()
    })

    // $('#branding .join-us a').on('click', function(e){
    //     let off = $('#sp-section-9').offset().top
    //     $('html,body').stop().scrollTop(off - 1000)
    //     $('html,body').stop().animate({
    //         'scrollTop': off
    //     }, 2000)
    //     e.preventDefault()
    // })

    ///// JUMP NAV /////
    const jumpNavChange = (id) => {
        $('#jump-nav .jump-item').removeClass('active')
        $('#jump-nav .jump-item-' + id).prevAll().each(function(i){
            let opac = ((10-i) * .1) - 0.3
            if(opac < 0.2) opac = 0.2
            $(this).css("opacity", opac);
        })
        $('#jump-nav .jump-item-' + id).nextAll().each(function(i){
            let opac = ((10-i) * .1) - 0.3
            if(opac < 0.2) opac = 0.2
            $(this).css("opacity", opac);
        })
        $('#jump-nav .jump-item-' + id).addClass('active').css("opacity", 1.0)
    }

    $('.jump-item a').on('click', function(e){
        $('html,body').stop()
        if(scrollTl) scrollTl.kill()
        pauseAutoPlay()
        const el = $(this).attr('href')
        if(el.length > 1) {
            let currentOff = $('html,body').scrollTop()
            let off = $(el).first().offset().top
            if(el == "#sp-section-10") off-=550

            if(currentOff < off) {
                $('html,body').stop().scrollTop(off-1000)
            } else {
                $('html,body').stop().scrollTop(off+1000)
            }
            
            scrollToPosition(off)

            e.preventDefault()
        }
    })

    gsap.utils.toArray(".sp-section").forEach((section, i) => {
        ScrollTrigger.create({
            trigger: section,
            start: "top bottom",
            end: "bottom bottom",
            onEnter: () => jumpNavChange(section.id),
            onEnterBack: () => jumpNavChange(section.id)
        })
    })

    ///// EVENT TRANSITIONS /////

    // Center Text Flip
    let centerTextFlipIn = (elem) => gsap.to(elem, {
        opacity: 1,
        overwrite: true,
        ease: ease,
        onComplete: ()=> {
            gsap.to(elem,{
                rotationY: -180,
                duration: 0.5,
                //force3d: false,
            })
        }
    })
    let centerTextFlipOut = (elem) => gsap.to(elem, {
        opacity: 0,
        overwrite: true,
        ease: ease,
        onComplete: ()=> {
            gsap.set(elem,{
                rotationY: 0,
                //force3d: false,
            })
        }
    })

    // Slides Loop
    const theExperience = () => gsap.utils.toArray(".sp-slide").forEach((slide, i) => {
        let slideScrollIn = $(slide).hasClass('slide-scroll-in')
        let slideScrollOut = $(slide).hasClass('slide-scroll-out')
        let mainImage = $(slide).find("div.full-image")
        let isBlurInOut = mainImage.hasClass('image-blur-in-out')
        let isZoomOut = mainImage.hasClass('image-zoom-out')
        let isZoomIn = mainImage.hasClass('image-zoom-in')
        let isZoomInSlow =  mainImage.hasClass('image-zoom-in-slow')
        let isScaleIn = mainImage.hasClass('image-scale-in')
        let isScaleInFromBottom = mainImage.hasClass('image-scale-in-from-bottom')
        let isPanZoomLowerright = mainImage.hasClass('image-pan-zoom-lower-right')
        let delayTextIn = $(slide).hasClass('delay-text-transition-in')
        let llt = slide.querySelector(".lower-left-region")
        let lct = slide.querySelector(".left-center-text")
        let isFirstSlideInSection = slide.classList.contains('sp-slide-1')
        let centerTextFade = slide.querySelector(".center-text-fade") ? slide.querySelector(".center-text-fade") : 
            slide.querySelector(".center-text-two-part-delay") ? slide.querySelector(".center-text-two-part-delay") : 
            slide.querySelector(".center-text-two-title-swap") ? slide.querySelector(".center-text-two-title-swap") : 
            slide.querySelector(".center-text-stagger") ?  slide.querySelector(".center-text-stagger") :
            slide.querySelector(".center-text-track-in-scale-up") ? slide.querySelector(".center-text-track-in-scale-up") :
            slide.querySelector(".center-region .main-text:not(.center-text-track):not(.center-text-word-track)")
        let centerTextFlip = slide.querySelector(".center-text-flip")
        let trackInScaleUp = slide.querySelector(".center-text-track-in-scale-up")
        let twoPanelClip = $(slide).find('.two-panel-clip')
        let twoTitleSwap = $(slide).find('.two-title-swap')
        let splitPanelClip = $(slide).find('.split-panel-clip')
        let splitPanelSlide = $(slide).find('.sp-slide-secondary')
        let multiTitles = $(slide).hasClass('has-multi-titles') ? $(slide).find('.main-text-item') : false
        let joinUsForm = $(slide).find('#join-us-form')

        if(centerTextFlip) {
            gsap.set(centerTextFlip, {
                scale: 0.25
            })
        }

        // multi titles
        if(multiTitles) {
            for (let ii = 0; ii < multiTitles.length; ii++) {
                let offset = 120 * ii
                gsap.timeline({
                    scrollTrigger: { 
                        trigger: slide,
                        start: "top bottom-=" + offset + '%',
                        end: "top top-=" + offset + '%',
                        scrub: isDesktop ? 1.2 : true,
        
                    }                
                })
                .to(multiTitles[ii], {
                    opacity: 1
                })
                .to(multiTitles[ii], {
                    opacity: 1
                })
                .to(multiTitles[ii], {
                    opacity: () => ii+1==multiTitles.length && $('.sp-slide').length == i+1 ? 1 : 0
                })
            }
        }

        // two panel clip
        if(twoPanelClip.length > 0) {
            gsap.timeline({
                scrollTrigger: { 
                    trigger: slide,
                    start: "top-=10% bottom",
                    end: "top top",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(twoPanelClip.find(".clip1"), {
                y: "100%",
            })

            gsap.timeline({
                scrollTrigger: { 
                    trigger: slide,
                    start: "top-=10% bottom",
                    end: "top top",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(twoPanelClip.find(".clip2"), {
                y: "-100%",
            })
        }

        // split panel clip
        if(splitPanelSlide.length > 0) {
            // slide up
            gsap.timeline({
                scrollTrigger: { 
                    trigger: slide,
                    start: "top top-=20%",
                    end: "top top-=50%",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(splitPanelSlide, {
                top: "0",
            })

            // right panel text events
            gsap.timeline({
                scrollTrigger: { 
                    trigger: slide,
                    start: "top top",
                    end: "top top-=100%",
                    scrub: isDesktop ? 1.2 : true,
                    onEnter: () => {
                        splitPanelSlide.find('.lower-left-region').stop().animate({
                            opacity: 1
                        })
                    },
                    onEnterBack: () => {
                        splitPanelSlide.find('.lower-left-region').stop().animate({
                            opacity: 1
                        })
                    },
                    onLeave: () => {
                        splitPanelSlide.find('.lower-left-region').stop().animate({
                            opacity: 0
                        })
                    },
                    onLeaveBack: () => {
                        splitPanelSlide.find('.lower-left-region').stop().animate({
                            opacity: 0
                        })
                    },
                }
            })

            // clip 1
            gsap.timeline({
                scrollTrigger: { 
                    trigger: slide,
                    start: "top top-=90%",
                    end: "bottom bottom",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(splitPanelClip.find(".clip1"), {
                y: "0",
            })

            // clip 2
            gsap.timeline({
                scrollTrigger: { 
                    trigger: slide,
                    start: "top top-=90%",
                    end: "bottom bottom",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(splitPanelClip.find(".clip2"), {
                y: "0",
            })


            gsap.timeline({
                scrollTrigger: { 
                    trigger: slide,
                    start: "bottom bottom",
                    end: "bottom top",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(slide, {
                opacity: 0.0
            })        
        }

        // two title swap
        if(twoTitleSwap.length > 0) {
            gsap.timeline({
                scrollTrigger: { 
                    trigger: slide,
                    start: "top top",
                    end: "top top-=40%",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(twoTitleSwap.find("h2").first(), {
                opacity: 0,
            })

            gsap.timeline({
                scrollTrigger: { 
                    trigger: slide,
                    start: "top top",
                    end: "top top-=30%",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(twoTitleSwap.find("h2.swap"), {
                opacity: 1,
            })
        }
        

        // IMAGE TRANSITIONS
        // Join Us Form Full Image transition
        if(isScaleInFromBottom) {

            // title
            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: "top bottom",
                    end: "top center-=20%",
                    onEnter: () => {
                        $(slide).find('.center-region h2').first().stop().animate({
                            opacity: 1
                        })
                    },
                    onEnterBack: () => {
                        $(slide).find('.center-region h2').first().stop().animate({
                            opacity: 1
                        })
                    },
                    onLeave: () => {
                        $(slide).find('.center-region h2').first().stop().animate({
                            opacity: 0
                        })
                    },
                    onLeaveBack: () => {
                        $(slide).find('.center-region h2').first().stop().animate({
                            opacity: 0
                        })
                    },
                }
            })

            // scale in fade in
            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: "top-=10% bottom",
                    end: "top top",
                    scrub: isDesktop ? 1.2 : true,
                    onEnter: () => {
                        $(slide).find('.center-region #join-us-form').animate({
                            opacity: 0
                        })
                    },
                    onEnterBack: () => {
                        $(slide).find('.center-region #join-us-form').animate({
                            opacity: 0
                        })
                    },
                    onLeave: () => {
                        $(slide).find('.center-region #join-us-form').animate({
                            opacity: 1
                        })
                    },
                    onLeaveBack: () => {
                        $(slide).find('.center-region #join-us-form').animate({
                            opacity: 1
                        })
                    },
                }
            })
            .to(mainImage, {
                scale: () => 1,
                top: 0,
            })

        // Main Full Image Transitions
        } else {
            let mainImageStart = i+1==$('.sp-slide').length ? 'top bottom+=100%' : "top bottom+=10%"
            let mainImageEnd = i == 0 ? "bottom bottom+=100%" : slideScrollOut ? "bottom bottom" : "bottom bottom-=20%"
            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: ()=> mainImageStart,
                    end: () => mainImageEnd,
                    scrub: isDesktop ? 1.2 : true,
                    onEnter: () => {
                        slide.style.pointerEvents = "all"
                        if(slideScrollOut) $(slide).removeClass('slide-is-scrolling-out')

                    },
                    onEnterBack: () => {
                        slide.style.pointerEvents = "all"
                        if(slideScrollOut) $(slide).removeClass('slide-is-scrolling-out')

                    },
                    onLeave: () => {
                        slide.style.pointerEvents = "none"
                        if(slideScrollOut) $(slide).addClass('slide-is-scrolling-out')
                    },
                    onLeaveBack: () => {
                        slide.style.pointerEvents = "none"
                        if(slideScrollOut) $(slide).removeClass('slide-is-scrolling-out')
                    },
                }
            })
            .to(mainImage, {
                scale: () => isPanZoomLowerright ? 0.8 : isZoomInSlow ? 1.05 : isZoomIn ? 1.4 : isZoomOut ? 1.1 : 1,
                x: ()=> isPanZoomLowerright ? 0 : 0,
                y: ()=> isPanZoomLowerright ? 0 : 0,
                bottom: 0,
                filter: "blur(0px)",
                delay: () => isFirstSlideInSection ? 0.1 : 0
            })
            .to(mainImage, {
                filter: () => isBlurInOut ? "blur(10px)" : "none",
                scale: () => isPanZoomLowerright ? 1.2 : isZoomInSlow ? 1.1 : isZoomIn ? 1.6 : isZoomOut ? 1 : isScaleIn ? 1.4 : 1,
                x: ()=> isPanZoomLowerright ? '40%' : 0,
                y: ()=> isPanZoomLowerright ? '40%' : 0,
                bottom: 0,
            })
        }
        let mainImageStart = i+1==$('.sp-slide').length ? 'top bottom+=100%' : "top bottom+=10%"
        let mainImageEnd = i+1==$('.sp-slide').length ? 'top bottom' : i == 0 ? "bottom bottom+=100%" : slideScrollOut ? "bottom bottom" : "bottom bottom-=20%"

        // main image fade
        gsap.timeline({
            scrollTrigger: {
                trigger: slide,
                start: ()=> mainImageStart,
                end: () => mainImageEnd,
                scrub: isDesktop ? 1.2 : true,
            }
        })
        .to(mainImage.find('img'), {
            opacity: 1,
            delay: () => isFirstSlideInSection ? 0.1 : 0
        })
        .to(mainImage, {
            opacity: 1,
        })
        .to(mainImage, {
            opacity: () => i+1 == $('.sp-slide').length ? 1 : slideScrollOut ? 1 : 0,
        })
        
        let inStart = slideScrollIn ? "top top+=10%" : delayTextIn && slideScrollIn ? "top center": delayTextIn ? "top center" : "top bottom-=30%"
        let inEnd = "top top"
        let outStart = joinUsForm.length > 0 ? "top top-=6000%" : delayTextIn ? "top top-=60%" : "top top-=20%"
        let outEnd = joinUsForm.length > 0 ? "bottom bottom+=5000%" : trackInScaleUp ? "top top-=50%" : splitPanelSlide.length > 0 ? "top top-=100%" : delayTextIn && !slideScrollIn ? "top top-=100%" : "bottom bottom+=20%"

        // LLT 
        if(llt) {
            // in
            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: inStart,
                    end: inEnd,
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(llt, {
                opacity: 1
            })

            // out
            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: outStart,
                    end: outEnd,
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(llt, {
                opacity: 0
            })
        }

        // LCT AND CENTER TEXT FADE
        if(lct || centerTextFade) {
            let elem = lct ? lct : centerTextFade
            // in
            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: inStart,
                    end: inEnd,
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(elem, {
                opacity: 1,
            })

            // out
            if(!slideScrollOut) {
                gsap.timeline({
                    scrollTrigger: {
                        trigger: slide,
                        start: outStart,
                        end: outEnd,
                        scrub: isDesktop ? 1.2 : true,
                        
                    }
                })
                .to(elem, {
                    opacity: 0,
                })
            }

            if($(elem).find('.delayed').length > 0) {
                // delayed in
                gsap.timeline({
                    scrollTrigger: {
                        trigger: slide,
                        start: "top center",
                        end: "top top",
                        scrub: isDesktop ? 1.2 : true,
                    }
                })
                .to($(elem).find('.delayed'), {
                    opacity: 1
                })
            }
        }








        // Handle Event Transitions
        ScrollTrigger.create({
            trigger: slide,
            start: () => inStart,
            end: () => outEnd,
            onEnter: () => {
                if(centerTextFlip) centerTextFlipIn(centerTextFlip)
            },
            onEnterBack: () => {
                if(centerTextFlip) centerTextFlipIn(centerTextFlip)
            },
            onLeave: () => {
                if(!slideScrollOut) {
                    if(centerTextFlip) centerTextFlipOut(centerTextFlip)
                }
            },
            onLeaveBack: () => {
                if(centerTextFlip) centerTextFlipOut(centerTextFlip)
            },
        })

        // Center Text Transitions
        const centerTextZoom = $(slide).find('.center-text-zoom')
        const ctzElem = centerTextZoom.find("h2")
        if(ctzElem.length > 0) {
            gsap.set(ctzElem, {
                scale: 0.01,
            })
            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: "top top",
                    end: "bottom bottom",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(ctzElem, {
                scale: 1,
            })

            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: "top top",
                    end: "bottom bottom",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(centerTextZoom, {
                opacity: 1,
            })
            .to(centerTextZoom, {
                opacity: 0,
            })
        }

        const centerTextZoomReverse = $(slide).find('.center-text-zoom-reverse')
        const ctzrElem = centerTextZoomReverse.find("h2")
        if(ctzrElem.length > 0) {
            gsap.set(ctzrElem, {
                scale: 1,
            })
            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: "top bottom",
                    end: "bottom bottom+=40%",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(ctzrElem, {
                scale: 0.3,
                letterSpacing: "0.5em",
                opacity: 1,
            })
            .to(ctzrElem, {
                scale: 0.01,
                letterSpacing: "0.01em",
                opacity: 1,
            })
            .to(ctzrElem, {
                scale: 0.01,
                opacity: 0,
            })
        }

        const centerTextTrack = $(slide).find('.center-text-track')
        const centerTextTrackH2 = $(slide).find('.center-text-track h2')
        if(centerTextTrack.length > 0) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: "top bottom-=20%",
                    end: "top bottom-=60%",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(centerTextTrack, {
                opacity: 1
            })

            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: "bottom bottom+=70%",
                    end: "bottom bottom+=30%",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(centerTextTrack, {
                opacity: 0
            })

            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: "top bottom-=80%",
                    end: "bottom bottom",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(centerTextTrackH2, {
                letterSpacing: 100,
            })
        }

        const centerTextWordTrack = $(slide).find('.center-text-word-track')
        const centerTextWordTrackInner = $(slide).find('.center-text-word-track h2 span.space')
        if(centerTextWordTrack.length > 0) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: "top bottom",
                    end: "bottom bottom",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(centerTextWordTrack, {
                opacity: 1
            })
            .to(centerTextWordTrack, {
                opacity: 0
            })

            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: "top bottom",
                    end: "center bottom+=50%",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(centerTextWordTrackInner, {
                width: '10px'
            })
        }

        const trackInScaleUpInner = $(slide).find('.center-text-track-in-scale-up h2')
        if(trackInScaleUpInner.length > 0) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: () => "top bottom",
                    end: "top top",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(trackInScaleUpInner, {
                letterSpacing: 6,
                scale: 1.0,
            })
            .to(trackInScaleUpInner, {
                letterSpacing: 6,
                scale: 1.4,
            })
        }

        let staggerText = $(slide).find(".center-text-stagger h2 span")
        if(staggerText.length > 0) {
            gsap.timeline({
                scrollTrigger: {
                    trigger: slide,
                    start: () => "top center",
                    end: "top top-=20%",
                    scrub: isDesktop ? 1.2 : true,
                }
            })
            .to(staggerText, {
                y: 0,
            })
        }

        if(slideScrollIn) {
            ScrollTrigger.create({
                trigger: slide,
                start: "top bottom",
                end: "top top",
                scrub: isDesktop ? 1.2 : true,
                onEnter: () => $(slide).removeClass('slide-scroll-in-complete'),
                onEnterBack: () => $(slide).removeClass('slide-scroll-in-complete'),
                onLeave: () => $(slide).addClass('slide-scroll-in-complete'),
                onLeaveBack: () => $(slide).removeClass('slide-scroll-in-complete'),
            })
        }
    })
    theExperience()

    // to fix the scrolltrigger from getting strange on resize, scroll to bottom, then top, then to current position
    $(window).on('resize', function(){
        let pageOffset = $(document).scrollTop()
        $("html, body").stop().animate({ scrollTop: 0 }, 1);
        $("html, body").stop().animate({ scrollTop: $(document).height() }, 1);
        $("html, body").stop().animate({ scrollTop: pageOffset }, 1);
    }) 

}